import HowToIssueBusinessLoan from './HowToIssueBusinessLoan';

export default HowToIssueBusinessLoan;
